import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";

const useTokenHook = () => {
  return useSelector((state: RootState) => state.accessToken);
};

export default useTokenHook;
